import lazyLoad from '@utils/lazyLoad'

const activeRoutes = [
  {
    path: '/mailActives/pointExchange', // 积分换购
    exact: true,
    component: lazyLoad(() =>
      import('@views/AppMails/MailActives/PointExchange')
    ),
    layoutMode: 'empty',
    meta: {
      title: '全部订单',
      layoutMode: 'empty'
    }
  },
  {
    path: '/mailActives/pointExchange/edit/:id', // 编辑
    exact: true,
    component: lazyLoad(() =>
      import('@views/AppMails/MailActives/PointExchange/edit.js')
    ),
    layoutMode: 'empty',
    meta: {
      title: '编辑规则',
      layoutMode: 'empty'
    }
  }
]

export default activeRoutes
